import { useEffect, useState } from 'react';
import ReactPixel from 'react-facebook-pixel';
import useResponsive from './hooks/useResponsive';
// routes
import Router from './routes';
// theme
import ThemeProvider from './theme';
// components
import ThemeSettings from './components/settings';
// import { ChartStyle } from './components/chart';
import ScrollToTop from './components/ScrollToTop';
import { ProgressBarStyle } from './components/ProgressBar';
import NotistackProvider from './components/NotistackProvider';
import MotionLazyContainer from './components/animate/MotionLazyContainer';
import CustomConfirm from './components/CustomConfirm';
import LoadingScreen from './components/LoadingScreen';
import AngpaoAndCoinRain from './components/AngpaoAndCoinRain';
import ProfileDialogContainer from './components/ProfileDialogContainer';
import SplashScreen from './components/SplashScreen';
// ----------------------------------------------------------------------

export default function App() {
  const isDesktop = useResponsive('up', 'lg');
  const [isLoading, setIsLoading] = useState(!isDesktop);

  // Initialize Pixel ONCE
  useEffect(() => {
    const firstPixel = process.env.VITE_PIXEL_ID;
    const secondPixel = process.env.VITE_2FA_PIXEL_ID;

    const options = {
      autoConfig: true,
      debug: false,
    };

    if (firstPixel) {
      ReactPixel.init(firstPixel, undefined, options);
    }
    if (secondPixel) {
      ReactPixel.init(secondPixel, undefined, options);
    }

    ReactPixel.pageView(); // fires for both pixels
  }, []);

  useEffect(() => {
    if (isDesktop) return;

    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 3000);

    return () => clearTimeout(timer);
  }, [isDesktop]);

  if (!isDesktop && isLoading) {
    return (
      <ThemeProvider>
        <ThemeSettings>
          <SplashScreen />
        </ThemeSettings>
      </ThemeProvider>
    );
  }

  return (
    <MotionLazyContainer>
      <ThemeProvider>
        <AngpaoAndCoinRain isVisible={true} />
        <ThemeSettings>
          <NotistackProvider>
            <ProgressBarStyle />
            {/* <ChartStyle /> */}
            <ProfileDialogContainer />
            <ScrollToTop />
            <Router />
            <CustomConfirm />
            <LoadingScreen />
          </NotistackProvider>
        </ThemeSettings>
      </ThemeProvider>
    </MotionLazyContainer>
  );
}
